import { PlainIconButton } from "@tvg/fuse-buttons";
import { Link } from "@tvg/fuse-link";
import { gridConfig } from "@tvg/fuse-responsive-grid";
import { TypographyComponent } from "@tvg/fuse-typography-element";
import styled, { DataAttributes } from "styled-components";

export const StyledProposalsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const StyledProposal = styled.li.attrs<DataAttributes>({
  "data-testid": "proposed-search-term-wrapper",
})`
  display: flex;
  gap: var(--spacing-space8);
  align-items: center;
  align-self: stretch;
  justify-content: space-between;
`;

export const StyledProposalsWrapper = styled.ul`
  padding: 0;
  width: 100%;
  list-style: none;
`;

export const StyledRecentSearchesSectionNameWrapper = styled.div`
  display: flex;
  padding: var(--spacing-space12) 0;
  align-items: center;
  gap: var(--spacing-space8);
  align-self: stretch;
  justify-content: space-between;

  @media screen and (min-width: ${gridConfig.l.minWidth}) {
    padding: 0;
  }
`;

export const ClearAll = styled(TypographyComponent)`
  margin: 0;
`;

export const StyledClearButton = styled.button`
  background: none;
  border: 0;
  padding: 0;
  color: var(--color-global-grey900);
  border-radius: 0;

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: var(--spacing-space2);
  border-bottom: var(--border-width-xs) solid var(--color-greys-grey5, #bababa);
  cursor: pointer;

  &:hover,
  &:active {
    border: 0;
    box-shadow: none;
    border-bottom: var(--border-width-xs) solid;
  }

  &:active {
    span {
      color: var(--color-brand-dark);
    }
    border-color: var(--color-brand-dark);
  }

  &:hover,
  &:focus {
    span {
      color: var(--color-brand-dark);
    }
    border-color: var(--color-brand-dark);
  }

  &:focus-visible {
    outline: var(--spacing-space2) solid var(--color-functional-focus);
    outline-offset: var(--spacing-space2);
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }

  &:after {
    content: "";
    display: block;
    min-height: 44px;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    min-width: 44px;
    width: 100%;
  }
`;

export const StyledClearAll = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: var(--spacing-space2);
  border-bottom: var(--border-width-xs) solid;
  color: var(--color-greys-grey9);
  border-color: var(--color-greys-grey9);
  cursor: pointer;
`;

export const TermLink = styled(Link)`
  flex-grow: 1;
  line-height: var(--font-line-height-1);
  text-decoration: none;
  color: var(--color-base-black, #000000);
  padding: var(--spacing-space12) var(--spacing-space8);
`;

export const RemoveTermButton = styled(PlainIconButton)`
  margin-right: var(--spacing-space8);
`;

export const StyledBoldTerm = styled.span`
  font-weight: 700;
`;
